import script from "./sortScreenPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./sortScreenPhone.vue?vue&type=script&setup=true&lang=js"

import "./sortScreenPhone.vue?vue&type=style&index=0&id=706b10fc&lang=scss&scoped=true"

import exportComponent from "F:\\tubida\\tbd_screen_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706b10fc"]])

export default __exports__